import React from 'react'
import { Layout, SectionTitle, Showcase, Header } from '../../../../components'

import './style.scss'
import data from './data.json'
import ILSpace from '../../../../images/MTBLists_IL_Spacing.png'
import ULOLSpace from '../../../../images/MTBLists_UL-OL_Spacing.png'
import HorizMargin from '../../../../images/MTBLists_Top-Bottom_Margin.png'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
        exclusive={true}
      />
      <Layout
        description={data.description}
        site={data.site}
        slug={data.slug + '/design/'}
        state="design"
        title={data.title}
      >
        <SectionTitle>Variants</SectionTitle>
        <p>
          Too many lists in a single layout will no longer stand out. Make sure
          to use them only when the information needs to be more readable.
        </p>
        <Showcase
          site={data.site}
          title="Ordered List"
          text="Pairing list items with numbers helps the user recognize that the order or total number of items is important."
          code={code.orderedList}
        >
          <ol class="c-ordered-list">
            <li class="c-ordered-list__item">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </li>
            <li class="c-ordered-list__item">
              Euismod nisi porta lorem mollis
            </li>
            <li class="c-ordered-list__item">
              Neque volutpat ac tincidunt vitae semper
            </li>
          </ol>
        </Showcase>
        <Showcase
          site={data.site}
          title="Unordered List"
          text="Pairing list items with bullets helps the user recognize that all content presented is of equal status or value."
          code={code.unorderedList}
        >
          <ul class="c-unordered-list">
            <li class="c-unordered-list__item">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit
            </li>
            <li class="c-unordered-list__item">
              Euismod nisi porta lorem mollis
            </li>
            <li class="c-unordered-list__item">
              Neque volutpat ac tincidunt vitae semper
            </li>
          </ul>
        </Showcase>
        <Showcase
          site={data.site}
          title="Icon List"
          text="Pairing list items with icons makes the unordered content the primary focus in a layout."
          code={code.iconList}
        >
          <ul
            class="c-icon-list layout--thinner"
            arialabelledby="accountdetailslabel"
          >
            <li class="c-icon-list__item undefined">
              <span class="c-icon-list__icon">
                <i class="icon icon--stopwatch"></i>
              </span>
              <span class="c-icon-list__content">
                Lorem ipsum dolor sit amet, consectetur adipiscing elit
              </span>
            </li>
            <li class="c-icon-list__item undefined">
              <span class="c-icon-list__icon">
                <i class="icon icon--person"></i>
              </span>
              <span class="c-icon-list__content">
                Euismod nisi porta lorem mollis
              </span>
            </li>
            <li class="c-icon-list__item list__item--less-space">
              <span class="c-icon-list__icon">
                <i class="icon icon--piggy-bank"></i>
              </span>
              <span class="c-icon-list__content">
                Neque volutpat ac tincidunt vitae semper
              </span>
            </li>
          </ul>
        </Showcase>
        <hr />
        <SectionTitle>Design Environment</SectionTitle>
        <Showcase
          site={data.site}
          title="Space Around Lists"
          text="There should be a top and bottom margin of at least 24px between a
          list and any preceding or following text content. For
          ordered and unordered lists only, the entire list component should be
          indented 16px from the left side of the title, text content or
          component that precedes it. If there are no components preceding the
          list, the component should be indented 16px from the left side margin."
        >
          <img
            src={HorizMargin}
            alt="Example of horizontal margin on lists"
          ></img>
        </Showcase>
        <Showcase
          site={data.site}
          title="Space Between List Items"
          text="Use at least 16px of space in between each ordered and unordered list
          item. In icon lists, increase the space between items to 24px."
        >
          <img
            src={ULOLSpace}
            alt="Example of spacing between ordered and unordered list items"
          ></img>
          <img
            src={ILSpace}
            alt="Example of spacing between Icon list items"
          ></img>
        </Showcase>
        <hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Try to keep all items in a single list to similar line lengths. Use
          sentence case with no end punctuation, even if the list item is a
          complete sentence. If there is more than one sentence in the list
          item, use periods in all sentences except the last one.
        </p>
      </Layout>
    </>
  )
}

export const code = {
  /*
  orderedList: `<ol class="c-ordered-list">
    <li class="c-ordered-list__item">List Item</li>
    <li class="c-ordered-list__item">List Item</li>
    <li class="c-ordered-list__item">List Item</li>
</ol>
`,
  unorderedList: `<ul class="c-unordered-list">
    <li class="c-unordered-list__item">List Item</li>
    <li class="c-unordered-list__item">List Item</li>
    <li class="c-unordered-list__item">List Item</li>
</ul>`,
  iconList: `<ul class="c-icon-list layout--thinner" arialabelledby="accountdetailslabel">
    <li class="c-icon-list__item undefined">
        <span class="c-icon-list__icon">
            <Icon/>
        </span>
        <span class="c-icon-list__content">List Item</span>
    </li>
    <li class="c-icon-list__item undefined">
        <span class="c-icon-list__icon">
            <Icon/>
        </span>
        <span class="c-icon-list__content">List Item</span>
    </li>
    <li class="c-icon-list__item list__item--less-space">
        <span class="c-icon-list__icon">
            <Icon/>
        </span>
        <span class="c-icon-list__content">List Item</span>
    </li>
</ul>
`,*/
}
